import { ChangeDetectorRef, Component } from "@angular/core";
import { PanelService } from "@sharedV11/services/panel/panel.service";
import { SuperClassComponent } from "@sharedV11/super-class-edit/super-class/super-class.component";
import { EditLugaresComponent } from "./edit-lugares/edit-lugares.component";

@Component({
  selector: "app-lugares",
  templateUrl: "./lugares.component.html",
  styleUrls: ["./lugares.component.css"],
})
export class LugaresComponent extends SuperClassComponent {
  constructor(
    protected panelService: PanelService,
    protected cdRef: ChangeDetectorRef
  ) {
    super(panelService, cdRef);
  }

  openPanel() {
    this.customanpanel = EditLugaresComponent;
    this.editChangeCss();
    this.cdRef.detectChanges();
  }
}


